// extracted by mini-css-extract-plugin
export var timePadding = "index-module--timePadding--3hg3w";
export var timeContainer = "index-module--timeContainer--1BCJ9";